import { useState } from "react";
import { useMutation } from "convex/react";
import { api } from "../../../convex/_generated/api";
import type { LoggingFlowReviewItem } from "../../lib/logging-flow";
import { applyOptimisticMealBatch } from "../../lib/meal-log-optimistic";
import type { MealEstimateData } from "./card-data";
import { MealEstimateCardView } from "./meal-estimate-card-view";
import { submitMealEstimateLog, type MealEstimateLogState } from "./meal-estimate-log";

export interface MealEstimateCardProps {
  readonly data: MealEstimateData;
  readonly onStartReview?: (items: readonly LoggingFlowReviewItem[]) => void;
  readonly onSendMessage?: (text: string) => void;
}

export function MealEstimateCard(props: MealEstimateCardProps) {
  const [logState, setLogState] = useState<MealEstimateLogState>({ kind: "idle" });
  const logMeal = useMutation(api.meals.logMealBatch).withOptimisticUpdate(applyOptimisticMealBatch);
  const handleLog = () => {
    if (logState.kind === "logging" || logState.kind === "logged") return;
    setLogState({ kind: "logging" });
    void submitMealEstimateLog(logMeal, props.data, Date.now()).then(setLogState);
  };
  return <MealEstimateCardView {...props} logState={logState} onLog={handleLog} />;
}
